import React from 'react';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { DropdownItem, UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import ContentManager from 'src/componentes/content-manager';
import { capitalizeFirstLetter } from 'src/utils/string';
import { TIPO_ITENS, STATUS_ITEM } from 'src/utils/constants';

import history from 'src/history';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

import { SophieIcon } from 'src/componentes/icons';
import LucideIcon from 'src/componentes/lucide-icon';

const Mensagem = React.lazy(() => import('src/paginas/mensagem/modal'));
const EmbedPowerBI = React.lazy(() =>
  import('src/paginas/power-bi/componentes/power-bi-dialog')
);
const RiscoEditView = React.lazy(() =>
  import('src/paginas/gestao-risco/risco/RiscoEditView')
);
const ModalAvaliacoesRisco = React.lazy(() =>
  import('src/paginas/gestao-risco/risco/Avaliacao/ModalAvaliacoesRisco')
);

@autobind
class DropdownItemRisco extends React.Component {
  static defaultProps = {
    exibirEdicao: true,
    exibirFicha: true,
    exibirValor: true,
    exibirRelacionamento: true,
    exibirRelatorioAcompanhamento: true,
    exibirInteligenciaArtificial: false,
    exibirMensagem: true,
    exportResumo: false,
    exibirMatrizResultados: true,
    exibirPlanoAcao: true,
    exibirAvaliacoes: true,
    labelAI: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      utilizarCurvaS: false,
    };
  }

  getLabel(item) {
    const { renderLabel } = this.props;

    if (renderLabel) {
      return renderLabel;
    } else {
      return item.nome;
    }
  }

  getUrlItemExport(item) {
    let urlExportItem = null;

    if (item.tipo && item.tipo.id == TIPO_ITENS.INDICADOR)
      urlExportItem = `/Indicador/ExportResumoIndicador`;
    else if (item.tipo && item.tipo.id == TIPO_ITENS.PROJETO)
      urlExportItem = `/Projeto/ExportResumoPlanoAcao`;

    return urlExportItem;
  }

  handleEditClick(item) {
    if (!item) return;

    ContentManager.addContent(
      <RiscoEditView
        paramsFiltro={this.state.searchEstatistica}
        mode="edit"
        handleClose={this.props.handleEditClose}
        {...this.props}
      />
    );
  }

  handleAvaliacoesClick(item) {
    if (!item) return;

    ContentManager.addContent(<ModalAvaliacoesRisco item={item} />);
  }

  obterFiltroUrl(item) {
    if (!item) return;

    const { filtro } = this.props;
    let url = `?itemId=${item.id}`;

    if (filtro != null && filtro != undefined) {
      url += `&openLastFilter=false`;

      // Tipo Filtro Data
      if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0)
        url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;

      // Data Inicio
      if (filtro.dataInicio != null) url += `&dataInicio=${filtro.dataInicio}`;

      // Data Termino
      if (filtro.dataTermino != null)
        url += `&dataTermino=${filtro.dataTermino}`;
    }

    return url;
  }

  handleValueClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/valor',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handlePlanoAcaoClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/gantt',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleMensagemClick(item) {
    ContentManager.addContent(<Mensagem fromItem item={{ id: item.id }} />);
    this.props.callback && this.props.callback();
    this.props.closePopover && this.props.closePopover();
  }

  handleRelacionamentosClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/arvore',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleMatrizResultadosClick(item) {
    let url = this.obterFiltroUrlMatrizResultados(item);

    history.push({
      pathname: '/acompanhar/matriz-resultado',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleClickSophie(item) {
    this.props.handleClickSophieCallBack &&
      this.props.handleClickSophieCallBack(item);
  }

  handleStatusReport(item) {
    const filterUrl = `?id=${item.id}&activeTab=7`;
    const pathName = '/gerenciar/projeto/edit';
    history.push({
      pathname: pathName,
      search: filterUrl,
    });
    this.props.callback && this.props.callback();
    this.props.closePopover && this.props.closePopover();
  }

  handleResumoProjeto(item) {
    history.push(`/gerenciar/projeto/resumo?id=${item.id}`);
  }

  handleIndicadoresEParametrosProjetos(item) {
    history.push({
      pathname: '/gerenciar/projeto/edit',
      search: `?id=${item.id}&activeTab=9`,
    });
  }

  handleTermoAberturaProjetos(item) {
    history.push({
      pathname: '/gerenciar/projeto/edit',
      search: `?id=${item.id}&activeTab=10`,
    });
  }

  handleRelatorioBIClick(item) {
    http
      .post(`/PowerBI/ObterConfiguracoesPorTipoItem`, {
        itemId: item.id,
        tipoItemId: item.tipo?.id,
      })
      .then((response) => {
        if (item.desdobramento) {
          response.data.model.campo = null;
        }
        ContentManager.addContent(
          <EmbedPowerBI
            itemId={item.id}
            relatorioPBI={response.data.model.relatorioPBI}
            embedURL={response.data.model.embedURL}
            workspacePBI={response.data.model.workspacePBI}
            filtros={response.data.model.filtros}
            embedToken={response.data.model.embedToken}
            usarAutenticacaoMicrosoft={
              response.data.model.usarAutenticacaoMicrosoft
            }
          />
        );
        this.setState({
          isLoading: false,
          resources: {},
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });

    this.props.callback && this.props.callback();
    this.props.closePopover && this.props.closePopover();
  }

  getInternalTabGestaoMudancas(item) {
    if (item.tipo?.id === TIPO_ITENS.PROJETO) return 1;

    return 1;
  }

  handleRedirectGestaoMudancas(item) {
    const internalTab = this.getInternalTabGestaoMudancas(item);
    history.push({
      pathname: '/minhas-tarefas/gestao-mudancas',
      search: `?tab=1&tabInterna=${internalTab}&isNew=true&entityId=${item.id}`,
    });
  }

  render() {
    let {
      resources,
      item,
      exibirRelacionamento,
      exibirMensagem,
      exibirInteligenciaArtificial,
      showEdit = false,
      labelAI,
      tooltipAI,
      exibirPowerBI = true,
      intl,
      exibirPlanoAcao,
      exibirAvaliacoes,
    } = this.props;

    const tipoId = item && item.tipo && item.tipo.id;

    const reprovadoDefinitivoFluxoAprovacao =
      item?.fluxoAprovacao && item?.status?.id === STATUS_ITEM.REPROVADO;
    const reprovadoFluxoAprovacao =
      item?.fluxoAprovacao &&
      item?.status?.id === STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO;
    const emPlanejamentoFluxoAprovacao =
      item?.fluxoAprovacao && item?.status?.id === STATUS_ITEM.EM_PLANEJAMENTO;

    exibirPowerBI = exibirPowerBI
      ? item?.permissions
        ? item?.permissions?.allowViewPowerBI
        : true
      : false;

    if (item && item.permissions && item.permissions.allowBasic) {
      exibirRelacionamento = false;
      exibirPlanoAcao = false;
      exibirMensagem = false;
      exibirAvaliacoes = false;
    } else {
      if (tipoId == 6) {
        exibirRelacionamento = true;
        exibirAvaliacoes = true;
      }

      if (item && item.ocultarMenus) {
        exibirRelacionamento = false;
        exibirPlanoAcao = false;
        exibirMensagem = false;
        exibirAvaliacoes = false;
      }

      if (item && item.exibirItensCardMetas) {
        exibirRelacionamento = false;
        exibirPlanoAcao = false;
        exibirMensagem = false;
        exibirAvaliacoes = false;
      }

      return [
        showEdit && (
          <DropdownItem key="1" onClick={this.handleEditClick.bind(this, item)}>
            <LucideIcon icon="Pencil" className="mr-2" />
            <FormattedMessage
              id="label.editar"
              values={{ editar: resources.editar }}
            />
          </DropdownItem>
        ),

        !reprovadoDefinitivoFluxoAprovacao &&
          !reprovadoFluxoAprovacao &&
          !emPlanejamentoFluxoAprovacao &&
          exibirAvaliacoes && (
            <DropdownItem
              key="3"
              onClick={this.handleAvaliacoesClick.bind(this, item)}
            >
              <LucideIcon className="mr-2" icon="ClipboardList" />
              {capitalizeFirstLetter(resources.avaliacoes)}
            </DropdownItem>
          ),

        exibirRelacionamento && (
          <DropdownItem
            key="4"
            onClick={this.handleRelacionamentosClick.bind(this, item)}
          >
            <LucideIcon className="mr-2" icon="Network" />
            {capitalizeFirstLetter(resources.relacionamentos)}
          </DropdownItem>
        ),

        !reprovadoDefinitivoFluxoAprovacao &&
          !reprovadoFluxoAprovacao &&
          !emPlanejamentoFluxoAprovacao &&
          exibirPlanoAcao &&
          tipoId !== 2 && (
            <DropdownItem
              key="6"
              onClick={this.handlePlanoAcaoClick.bind(this, item)}
            >
              <LucideIcon className="mr-2" icon="ChartNoAxesGantt" />
              {capitalizeFirstLetter(resources.planodeacao)}
            </DropdownItem>
          ),

        exibirMensagem && (
          <DropdownItem
            key="10"
            onClick={this.handleMensagemClick.bind(this, item)}
          >
            <LucideIcon className="mr-2" icon="MessageSquareText" />
            <FormattedMessage id="label.mensagens" />
          </DropdownItem>
        ),

        exibirPowerBI && (
          <DropdownItem
            key="13"
            onClick={this.handleRelatorioBIClick.bind(this, item)}
          >
            <LucideIcon className="mr-2" icon="Clipboard" />
            <FormattedMessage id="bi" />
          </DropdownItem>
        ),

        exibirInteligenciaArtificial && (
          <>
            <DropdownItem
              id="menuAI"
              key="16"
              onClick={this.handleClickSophie.bind(this, item)}
            >
              <SophieIcon className="pr-2" />
              {intl.formatMessage(
                { id: labelAI },
                { riscos: resources.riscos }
              )}
            </DropdownItem>
            {tooltipAI && (
              <UncontrolledTooltip placement="auto" target={'menuAI'}>
                {this.props.intl.formatMessage(
                  {
                    id: tooltipAI,
                  },
                  { riscos: resources.riscos }
                )}
              </UncontrolledTooltip>
            )}
          </>
        ),
      ];
    }
  }
}

function mapStateToProps(state) {
  return {
    modules: state.user.licenca.modulos,
  };
}

export default injectIntl(connect(mapStateToProps)(DropdownItemRisco));
